import { buildApiUrl } from "../../../lib/utils";

export function getInitials(name?: string | null): string {
  if (!name?.trim()) return "U";
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

export function resolveImageUrl(path?: string | null): string | undefined {
  if (!path) return undefined;
  if (
    path.startsWith("http://") ||
    path.startsWith("https://") ||
    path.startsWith("data:")
  ) {
    return path;
  }
  try {
    return buildApiUrl(path);
  } catch {
    return path;
  }
}

export function formatDateTime(value?: string | null): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function getRoleLabel(
  roles?: string[] | string | [string] | null,
  userType?: string
): string {
  if (Array.isArray(roles) && roles.length > 0) {
    return roles.filter(Boolean).join(" · ");
  }
  if (typeof roles === "string" && roles.trim()) return roles;
  if (userType) return userType;
  return "Admin";
}

export function getDeviceLabel(): string {
  if (typeof navigator === "undefined") return "This device";
  const ua = navigator.userAgent;
  const browser = ua.includes("Edg/")
    ? "Edge"
    : ua.includes("Chrome")
    ? "Chrome"
    : ua.includes("Safari")
    ? "Safari"
    : ua.includes("Firefox")
    ? "Firefox"
    : "Browser";
  const os = ua.includes("Mac")
    ? "macOS"
    : ua.includes("Windows")
    ? "Windows"
    : ua.includes("Linux")
    ? "Linux"
    : ua.includes("Android")
    ? "Android"
    : ua.includes("iPhone") || ua.includes("iPad")
    ? "iOS"
    : "this device";
  return `${browser} on ${os}`;
}
